export const DEFAULT_SELECTION_WIDTH_RATIO = 0.55;
export const DEFAULT_SELECTION_HEIGHT_RATIO = 0.45;
export const DEFAULT_SELECTION_MARGIN = 80;
export const MAX_EXPORT_SIDE = 8192;
export const MAX_EXPORT_SCALE = 50;
